export type {AvatarImageProps} from './types';
export {AvatarImage} from './AvatarImage';
